import * as React from 'react'
import cn from 'classnames'

import ButtonCard from './ButtonCard/ButtonCard'
import Category from './Category/Category'
import Featured from './Featured/Featured'
import Occasion from './Occassion/Occasion'
import Profile from './Profile/Profile'

import styles from './Card.module.css'

export type CardSize = 'big' | 'small'
export type CardProps = {
  type: 'profile' | 'featured' | 'occasion' | 'button-card' | 'category'
  imageUrl?: string
  videoUrl?: string
  color?: string
  talentName?: string
  talentDescription?: string
  label?: string
  loading?: boolean
  price?: string
  originalPrice?: string
  expressDelivery?: '1h' | '24h'
  tag?: string
  discountPercent?: string
  icon?: string
  heading?: string
  content?: string
  size?: CardSize
  priceColor?: string
  priority?: boolean
}

// color: for occasion and category
const Card: React.FC<CardProps> = ({
  type,
  imageUrl,
  videoUrl,
  color,
  talentName,
  talentDescription,
  label,
  loading,
  price,
  originalPrice,
  expressDelivery,
  tag,
  discountPercent,
  icon,
  heading,
  content,
  size,
  priceColor,
  priority = false,
}) => {
  const showProfile = type === 'profile'
  const showFeatured = type === 'featured'
  const showOccasion = type === 'occasion'
  const showButtonCard = type === 'button-card'
  const showCategory = type === 'category'

  return (
    <div
      style={{
        backgroundColor: showOccasion && !loading && color,
        backgroundBlendMode: showOccasion && !loading && 'color-burn',
      }}
      className={cn(styles.cardContainer, styles[type], {
        [styles.loading]: loading,
        [styles.buttonCardBig]: showButtonCard && size === 'big',
        [styles.buttonCardSmall]: showButtonCard && size === 'small',
        [styles.featuredBig]: showFeatured && size === 'big',
      })}
    >
      {showProfile && (
        <Profile
          talentName={talentName}
          talentDescription={talentDescription}
          imageUrl={imageUrl}
          videoUrl={videoUrl}
          price={price}
          originalPrice={originalPrice}
          expressDelivery={expressDelivery}
          tag={tag}
          discountPercent={discountPercent}
          loading={loading}
        />
      )}

      {showFeatured && (
        <Featured
          imageUrl={imageUrl}
          videoUrl={videoUrl}
          talentName={talentName}
          talentDescription={talentDescription}
          price={price}
          size={size}
          priceColor={priceColor}
          priority={priority}
        />
      )}

      {showOccasion && <Occasion icon={icon} label={label} loading={loading} />}

      {showButtonCard && (
        <ButtonCard
          heading={heading}
          content={content}
          label={label}
          size={size}
        />
      )}

      {showCategory && (
        <Category
          loading={loading}
          label={label}
          imageUrl={imageUrl}
          color={color}
        />
      )}
    </div>
  )
}

export { Card as default, Card }
